(() => {
  if (window.peProtectionStatusReady) return;
  window.peProtectionStatusReady = true;
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('[data-pe-protection-status]').forEach(status => {
      const root = status.closest('#mini-cart, .cart__aside-inner');
      const widget = root?.querySelector('.sam__protect--wrapper');
      const toggle = widget?.querySelector('input.sam_switch_btn');
      if (!toggle || !widget.getClientRects().length || getComputedStyle(widget).display === 'none') {
        status.hidden = true;
        return;
      }
      const feeNode = widget.querySelector('.sam-protect-estimate, .sam-protect-fee');
      const fee = feeNode?.textContent.replace(/^[\s(]+|[\s)]+$/g, '').trim();
      const selected = toggle.checked;
      const text = selected && fee ? status.dataset.selected.replace('__fee__', fee) : status.dataset.unselected;
      if (status.textContent !== text) status.textContent = text;
      status.hidden = false;
      toggle.setAttribute('aria-label', widget.querySelector('.sam__widget--title')?.textContent.trim() || 'Shipping protection');
      toggle.setAttribute('aria-checked', String(selected));
    });
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(update);
    }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('input.sam_switch_btn')) schedule();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.sam__protect--wrapper')) schedule();
  });
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const observer = new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('[data-pe-protection-status]'))) schedule();
  });
  const start = () => {
    document.querySelectorAll('#mini-cart, .cart__aside-inner').forEach(root => {
      observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked', 'disabled']});
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
